var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssentials({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71429 3H27.2857C30.4416 3 33 5.55837 33 8.71429V27.2857C33 30.4416 30.4416 33 27.2857 33H8.71429C5.55837 33 3 30.4416 3 27.2857V8.71429C3 5.55837 5.55837 3 8.71429 3ZM25.8571 19.7857C26.4489 19.7857 26.9286 19.306 26.9286 18.7143V14.3714C26.9209 13.7829 26.4457 13.3077 25.8571 13.3H21.5714C20.9797 13.3 20.5 13.7797 20.5 14.3714C20.5 14.9632 20.9797 15.4429 21.5714 15.4429H22.8429L17.7571 20.5286L14.9 17.6714C14.1418 16.9159 12.9153 16.9159 12.1571 17.6714L8.48571 21.3429C8.06792 21.7612 8.06792 22.4388 8.48571 22.8571C8.68555 23.0595 8.95848 23.1728 9.24286 23.1714C9.52756 23.1744 9.8011 23.0609 10 22.8571L13.5857 19.4286L16.4429 22.2857C17.201 23.0413 18.4275 23.0413 19.1857 22.2857L24.7857 16.6429V18.7143C24.7857 19.306 25.2654 19.7857 25.8571 19.7857Z",
    fill: "#1B9075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentials);
export default __webpack_public_path__ + "static/media/essentials.213c7bee98866896f0fa659bc3267fce.svg";
export { ForwardRef as ReactComponent };